/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
import { createSlice } from '@reduxjs/toolkit';
import { StepSchema } from 'features/StepInfo/modal/types/stepSchema';
import backgroundImg1 from 'shared/assets/img/avatar/room-1700.png';
import backgroundImg2 from 'shared/assets/img/avatar/room-1200.png';
import backgroundImg3 from 'shared/assets/img/avatar/room-1024.png';
import backgroundImg4 from 'shared/assets/img/avatar/room-768.png';
import backgroundImg5 from 'shared/assets/img/avatar/room-370.png';

const initialState: StepSchema = {
    role: null,
    step: 0,
    locationName: sessionStorage.getItem('locationName'),
    locationStep: +sessionStorage.getItem('locationStep'),
    age: 0,
    logoColor: '#FFFFFF',
    background: {
        1700: `url(${backgroundImg1})`,
        1200: `url(${backgroundImg2})`,
        1024: `url(${backgroundImg3})`,
        768: `url(${backgroundImg4})`,
        370: `url(${backgroundImg5})`,
        // 1700: sessionStorage.getItem('1700'),
        // 1200: sessionStorage.getItem('1200'),
        // 1024: sessionStorage.getItem('1024'),
        // 768: sessionStorage.getItem('768'),
        // 370: sessionStorage.getItem('370'),
    },
    windowWidth: 1700,
};

export const StepSlice = createSlice({
    name: 'StepInfo',
    initialState,
    reducers: {
        incrementStep: (state) => {
            state.step += 1;
        },
        dicrementStep: (state) => {
            state.step -= 1;
        },
        incrementLocationStep: (state) => {
            state.locationStep += 1;
            sessionStorage.setItem('locationStep', `${state.locationStep}`);
        },
        setLocation: (state, action) => {
            state.locationName = action.payload;
            sessionStorage.setItem('locationName', state.locationName);
        },
        setBackground: (state, { payload }) => {
            sessionStorage.setItem('1700', payload[1700]);
            sessionStorage.setItem('1200', payload[1200]);
            sessionStorage.setItem('1024', payload[1024]);
            sessionStorage.setItem('768', payload[768]);
            sessionStorage.setItem('370', payload[370]);

            state.background[1700] = sessionStorage.getItem('1700');
            state.background[1200] = sessionStorage.getItem('1200');
            state.background[1024] = sessionStorage.getItem('1024');
            state.background[768] = sessionStorage.getItem('768');
            state.background[370] = sessionStorage.getItem('370');
        },
        resetSteps: (state) => {
            state.step = 0;
            state.locationStep = 0;
            state.logoColor = '#26C93C';

            state.background = {
                1700: '#EFEFEF',
                1200: '#EFEFEF',
                1024: '#EFEFEF',
                768: '#EFEFEF',
                370: '#EFEFEF',
            };

            sessionStorage.setItem('locationStep', `${state.locationStep}`);
            sessionStorage.setItem('1700', '#EFEFEF');
            sessionStorage.setItem('1200', '#EFEFEF');
            sessionStorage.setItem('1024', '#EFEFEF');
            sessionStorage.setItem('768', '#EFEFEF');
            sessionStorage.setItem('370', '#EFEFEF');
        },
        setLogoColor: (state, { payload }) => {
            state.logoColor = payload;
        },
        setWindowWidth: (state, { payload }) => {
            state.windowWidth = payload;
        },
        setLocationData(state, { payload }) {
            sessionStorage.setItem('locationStep', payload.step);
            sessionStorage.setItem('locationName', payload.age);

            state.locationName = sessionStorage.getItem('locationName');
            state.locationStep = +sessionStorage.getItem('locationStep');
        },
    },
});

export const { actions: stepActions } = StepSlice;
export const { reducer: stepReducer } = StepSlice;
